import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { SecondaryArticle } from "scmp-app/components/my-news/my-daily-five/my-daily-five-article/secondary-article";
import { TertiaryArticle } from "scmp-app/components/my-news/my-daily-five/my-daily-five-article/tertiary-article";

export const Container = styled.div`
  position: relative;
  z-index: 1;
  ${theme.breakpoints.up("mediumDesktop")} {
    display: flex;
    align-items: stretch;
  }
`;

export const FirstArticleWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;

  inline-size: 100%;
  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 48.5%;
    margin-inline-end: 28px;
  }
`;
export const RestArticlesWrapper = styled.div`
  inline-size: 100%;

  column-count: 1;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 28px;

    column-count: 2;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 51.5%;
  }
`;

const RestArticles = () => css`
  break-inside: avoid;
  ${theme.breakpoints.up("tablet")} {
    inline-size: 100%;
  }
`;

export const StyledSecondaryArticle = styled(SecondaryArticle)`
  ${RestArticles}
`;
export const StyledTertiaryArticle = styled(TertiaryArticle)`
  ${RestArticles}
`;
